import { render, staticRenderFns } from "./TemplatePreviewInfoDialog.vue?vue&type=template&id=4c78ece1"
import script from "./TemplatePreviewInfoDialog.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports